import "./ScaffoldingInGuildford.module.css";
import Header from "@/reusable_sections/Header";
import Guildford from "./sections/Guildford";
import GuildfordIntro from "./sections/GuildfordIntro";
import GuildfordCoverage from "./sections/GuildfordCoverage";
import GuildfordAccess from "./sections/GuildfordAccess";
import GuildfordFaq from "./sections/GuildfordFaq";
import QuoteCta from "./sections/QuoteCta";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingInGuildfordPage() {
  return <div>
      <Header />
      <Guildford />
      <GuildfordIntro />
      <GuildfordCoverage />
      <GuildfordAccess />
      <GuildfordFaq />
      <QuoteCta />
      <Footer />
    </div>;
}